// import logo_yourfairshare from "../../assets/logo_homepage3.svg";
// import logo_yourfairshare from "../../assets/logo_homepage_new_2.svg";
import logo_yourfairshare from "../../assets/logo_azilis.png";
import Username from "../../components/Username/";
import Navigation from "../../components/Navigation";
import YearTab from "../../components/YearTab";
import React, { useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { useWindowDimensions } from "../../app/Home/ThirdPage";
import "./index.css";
import LangNav from "../LangNav";
import { createContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dashBird from "../../assets/shapes_svg/dashboards/dash-bird.svg";
import dashCheck from "../../assets/shapes_svg/dashboards/dash-check.svg";
import dashCube from "../../assets/shapes_svg/dashboards/dash-cube.svg";
import dashUser from "../../assets/shapes_svg/dashboards/dash-user.svg";
import dashBusiness from "../../assets/shapes_svg/dashboards/dash-business.svg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useUserModules } from "../UserModuleContext";
import locked from "../../assets/locked.svg";

export const YearTabContext = createContext();

export const Print = ({ content }) => {
  const componentRef = React.useRef(null);

  const onBeforeGetContentResolve = React.useRef(null);

  const [loading, setLoading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called"); // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called"); // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
    setLoading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "AwesomeFileName",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  React.useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  const handleButton = () => {
    console.log(reactToPrintContent());
  };

  return (
    // <div>
    //   {loading && <p className="indicator">onBeforeGetContent: Loading...</p>}
    //   <button onClick={handlePrint}>
    //     Print
    //   </button>

    <Skeleton1 ref={componentRef} content={content} />
    // </div>
  );
};

export const useContainerDimensions = (myRef) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getDimensions = () => ({
      width: myRef.current.scrollWidth,
      height: myRef.current.scrollHeight,
    });

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (myRef.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [myRef]);

  return dimensions;
};

const Skeleton1 = React.forwardRef(({ content }, ref) => {
  const { t } = useTranslation();
  const location = useLocation();
  const showedLocation = [
    "/company",
    "/product",
    "/ambition",
    "/reporting",
    "/client",
  ];
  const navigate = useNavigate();

  const overviewUrl = "/overview";
  const adminDashUrl = "/admin-dash";
  const ARDashUrl = "/ar-dash";
  const navigatorUrl = "/info-navigation";
  const [isOverview, setIsOverview] = useState(false);
  const [isNavigator, setIsNavigator] = useState(false);
  const [isAdminDash, setIsAdminDash] = useState(false);
  const [isARDash, setIsARDash] = useState(false);
  const { isModuleAccessible } = useUserModules();
  useEffect(() => {
    if (overviewUrl.includes(location.pathname)) {
      setIsOverview(true);
    } else {
      setIsOverview(false);
    }

    if (navigatorUrl.includes(location.pathname)) {
      setIsNavigator(true);
    } else {
      setIsNavigator(false);
    }

    if (adminDashUrl.includes(location.pathname)) {
      setIsAdminDash(true);
    } else {
      setIsAdminDash(false);
    }

    if (ARDashUrl.includes(location.pathname)) {
      setIsARDash(true);
    } else {
      setIsARDash(false);
    }
  }, [location.pathname, overviewUrl]);

  const [year, setYear] = useState("");
  const [yearParent, setYearParent] = useState("");
  const [chosenDash, setChosenDash] = useState("");

  useEffect(() => {
    if (showedLocation.includes(location.pathname)) {
      const queryParams = new URLSearchParams(location.search);
      const newYear = queryParams.get("year") || "";
      setYear(newYear);
      setYearParent(newYear);
    }
  }, [location.search, location.pathname, showedLocation]);

  const YearTabContextValue = useMemo(() => yearParent, [yearParent]);

  // const ref = useRef(null)
  const { height: heightWindow, width: widthWindow } = useWindowDimensions();
  // const {width,height} = useContainerDimensions(ref)
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setHeight(ref?.current?.clientHeight);
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up
  }, []);
  //   useEffect(() => {
  //     const interval = setInterval(() => {
  //         setHeight(ref.current.clientHeight)

  //         // // console.log(ref.current.clientHeight)
  //       }, 1000);

  //       return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  //     }, [])
  // const handleScroll = () => {
  // console.log(ref)
  // }

  const handleChooseAr = () => {
    setChosenDash("AR");
    navigate("/ar-dash");
  };

  const handleChooseAdminDash = () => {
    setChosenDash("admin");
    navigate("/admin-dash");
  };

  const handleChooseDashInfo = () => {
    navigate("/info-navigation");
  };
  return (
    <div className="ambition" ref={ref}>
      <div className="ambition__main w-100 d-flex flex-column">
        <div className="dash-bg">
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo_yourfairshare}
              alt=""
              className="ambition__top"
              style={{
                width: "10%",
                paddingLeft: "40px",
              }}
            />
            <div className="center-section">
              <div className="dash-ar" style={{ display: "flex" }}>
                {/* <div
                  onClick={() => setChosenDash("business")}
                  className={
                    chosenDash === "business"
                      ? "dash-chosen"
                      : "dash-not-chosen"
                  }
                  style={{ padding: "5px 10px" }}
                >
                  <img src={dashBusiness} alt="" width={27} height={24} />
                  <h5>{t("BUSINESS_DASH")}</h5>
                </div>
                <div
                  onClick={handleChooseAdminDash}
                  className={
                    chosenDash === "admin" ? "dash-chosen" : "dash-not-chosen"
                  }
                  style={{ padding: "5px 10px" }}
                >
                  <img src={dashCheck} alt="" width={27} height={24} />
                  <h5>{t("ADMIN_DASH")}</h5>
                </div>

                */}
                <div
                  onClick={() => {
                    setChosenDash("user");
                    navigate("/overview");
                  }}
                  className={
                    chosenDash === "user" ? "dash-chosen" : "dash-not-chosen"
                  }
                  style={{ padding: "5px 10px" }}
                >
                  <img src={dashUser} alt="" width={27} height={24} />
                  <h5>{t("USER_DASH")}</h5>
                </div>
                <div
                  onClick={!isModuleAccessible("AR") ? null : handleChooseAr}
                  className={`${
                    chosenDash === "AR" ? "dash-chosen" : "dash-not-chosen"
                  }`}
                  style={{ padding: "5px 10px", position: "relative" }}
                >
                  <div
                    className={!isModuleAccessible("AR") ? "locked-item" : ""}
                  >
                    <img src={dashCube} alt="" />
                    <h5>AR Dash</h5>
                  </div>

                  {!isModuleAccessible("AR") && (
                    <img
                      src={locked}
                      alt="Locked icon"
                      width={30}
                      height={45}
                      style={{
                        top: "10%",
                        left: "40%",
                        position: "absolute",
                        zIndex: 10,
                      }}
                    />
                  )}
                </div>
              </div>
              <div
                style={{ marginLeft: "16px" }}
                onClick={handleChooseDashInfo}
              >
                <img
                  src={dashBird}
                  alt=""
                  width={36}
                  height={36}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>

            <div className="ambition__main__top d-flex w-20 justify-content-end">
              <Link className="nav-link" to="/profile">
                <Username />
              </Link>
              <LangNav />
            </div>
          </div>
        </div>
        <div
          className="ambition__main__bottom d-flex flex-column"
          style={{ marginTop: isNavigator ? 0 : "8vh" }}
        >
          {isOverview || isAdminDash || isARDash || isNavigator ? (
            <YearTabContext.Provider value={YearTabContextValue}>
              {content}
            </YearTabContext.Provider>
          ) : (
            <>
              <Navigation />
              <YearTab setYearParent={setYearParent} />
              <YearTabContext.Provider value={YearTabContextValue}>
                {content}
              </YearTabContext.Provider>
            </>
          )}
        </div>
      </div>
    </div>
  );
});

export const Skeleton = ({ content }) => {
  return <Print content={content} />;
};

export default Skeleton;
